import { VehicleOption } from "../Model/VehicleOption";

/**
 * Transforms the inputs of the form into a customer object.
 */
export class VehicleOptionToDataTransformer {

  from(data) {
    let option = new VehicleOption()
      .setId(data.id)
      .setLabel(data.label);

    return option;
  }

}
